export class QueryStringHelper {
  public static getValuesFromQueryString(key: string): string[] {
    try {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      return params.getAll(key);
    } catch {
      return [];
    }
  }
}
